import { Story } from "~types/types";

import getArticleMetadata from "./getArticleMetadata";

declare const window: Window &
    typeof globalThis & {
        __bloomberg__: any;
    };

const refreshAbba = async (story: Story) => {
    await window.__bloomberg__?.refreshAbbaClient?.(getArticleMetadata(story));
};

export default refreshAbba;
